import { Box, Tooltip, Typography } from "@mui/material";
import { PricingSettingRow } from "./PriceSettingRow/PricingSettingRow";
import { Info } from "@mui/icons-material";
import { useTranslation } from "../../../../hooks/useTranslation";
import { PricingRule } from "../PricingSettings";

type DefaultRuleRowProps = {
  editingRuleId: string | undefined;
  setEditingRuleId: (_id: string | undefined) => void;
  defaultRule: PricingRule;
};

export const DefaultRuleRow = (props: DefaultRuleRowProps) => {
  const { editingRuleId, setEditingRuleId, defaultRule } = props;
  const { translate } = useTranslation(
    "pages.stores.pricingSettings.defaultRow",
  );

  return (
    <PricingSettingRow
      key="default"
      rule={defaultRule}
      isEditing={editingRuleId === "default"}
      onEditStart={() => setEditingRuleId("default")}
      onEditStop={() => {
        setEditingRuleId(undefined);
      }}
      deletable={false}
      url={`store/${defaultRule.marketplaceId}/price-settings`}
      method={"put"}
      showEdit={editingRuleId === undefined || editingRuleId === "default"}
      customHeader={
        <Box display="flex" justifyContent="center">
          <Typography fontWeight="bold">{translate("title")}</Typography>
          <Tooltip title={translate("info")}>
            <Info fontSize="small" style={{ marginLeft: 4 }} color="primary" />
          </Tooltip>
        </Box>
      }
    />
  );
};
